import React, { useState } from 'react'

import withRootContext from 'context/withRootContextHOC'
import { useServiceScheduleContext } from 'src/context/serviceScheduleContext'

import FormSteps from 'src/components/formSteps'
import PageContainer from 'src/components/pageContainer'
import WarningModal from 'src/components/warningModal'
import Modal from 'src/components/modal/generic'
import CouponField from 'src/components/couponField'
import Checkbox from 'components/forms/checkbox'
import MODAL from 'src/utils/modals'
import { formatPrice } from 'utils'
import SchedulingReview from '../../schedulingReview'

import { assetPrefix } from 'src/config/env_config'

import * as S from './styles'

const ReviewStep = (props) => {
  const [showTermsModal, setShowTermsModal] = useState(false)
  const [showPackageTermsModal, setShowPackageTermsModal] = useState(false)
  const { context } = props

  const {
    state: {
      modal,
      scheduleBody,
      formList,
      schedulingCoupon,
      bestDiscount,
      useTerms,
      packageUseTerms
    },
    functions
  } = useServiceScheduleContext()

  const {
    handleWarningModalClose,
    pricesInfo,
    addCouponToSchedule,
    removeCouponFromSchedule,
    handleAcceptSchedulingTerms,
    handleAcceptPackageUseTerms
  } = functions

  const {
    totalPriceWithDiscount
  } = pricesInfo()

  const isSchedulingFromPackage = !!scheduleBody?.isSchedulingFromPackage

  const openSchedulingTerms = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setShowTermsModal(true)
  }

  const openPackageTerms = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setShowPackageTermsModal(true)
  }

  return (
    <PageContainer isSchedulingSteps>
      <FormSteps show={false} context={context} finalStep>
        <S.PageContainer>
          <S.AlignWrappers>
            <S.WrapperTitle>
              <span>Falta pouco, revise o agendamento</span>
            </S.WrapperTitle>
            <SchedulingReview current schedule={scheduleBody} />
            {!scheduleBody?.isSchedulingFromPackage && (
              <CouponField coupon={schedulingCoupon} context={context} addCoupon={addCouponToSchedule} removeCoupon={removeCouponFromSchedule} bestDiscount={bestDiscount} />
            )}
            {
              formList?.map((scheduling, index) => {
                return (
                  <SchedulingReview key={'scheduling-' + index} schedule={scheduling.body} previousState={scheduling} />
                )
              })
            }
            <S.CheckboxWrapper twoPetsOrMore={formList?.length > 0} marginTop={scheduleBody?.isSchedulingFromPackage ? '32px' : '0'}>
              <Checkbox
                checked={useTerms}
                name='useTerms'
                onChangeCallback={() => handleAcceptSchedulingTerms()}
                label={<>Eu concordo com o <a href='#' onClick={openSchedulingTerms} rel='noreferrer'>Termo de uso</a></>}
              />

              {isSchedulingFromPackage && (
                <Checkbox
                  checked={packageUseTerms}
                  name='packageUseTerms'
                  onChangeCallback={() => handleAcceptPackageUseTerms()}
                  label={<>Eu concordo com o <a href='#' onClick={openPackageTerms} rel='noreferrer'>Termo de Adesão ao Pacote de Banhos</a></>}
                />
              )}
            </S.CheckboxWrapper>

            {!!formList.length && !scheduleBody?.isSchedulingFromPackage &&
              <S.CalcPrice>
                <img src={`${assetPrefix}/static/icons/money-outline.svg`} />
                <div>Total</div>
                <S.Total>
                  {formatPrice(totalPriceWithDiscount)}
                </S.Total>
              </S.CalcPrice>}
          </S.AlignWrappers>
        </S.PageContainer>
      </FormSteps>

      <WarningModal
        visible={!!modal}
        cancelLabel={modal?.cancelLabel}
        confirmLabel={modal?.confirmLabel}
        type={modal?.type}
        title={modal?.title}
        subtitle={modal?.subtitle}
        onConfirm={modal?.onConfirm}
        onCancel={modal?.onCancel || handleWarningModalClose}
        fullButton={modal?.fullButton}
        outlineCancelButton={modal?.outlineCancelButton}
        showClose={modal?.showClose}
        icon={modal?.icon ? modal?.icon : !modal?.professional ? `${assetPrefix}/static/icons/warning.svg` : ''}
        iconSize={modal?.iconSize}
        dataTest='modal-warning-scheduling'
      >
        {modal?.body}
      </WarningModal>

      <Modal
        {...MODAL.SCHEDULING_TERMS({
          visible: showTermsModal,
          onClose: () => setShowTermsModal(false)
        })}
      />

      <Modal
        {...MODAL.PACKAGE_ADHESION_TERMS({
          visible: showPackageTermsModal,
          onClose: () => setShowPackageTermsModal(false),
          hideActionButtons: true
        })}
      />
    </PageContainer>
  )
}

export default withRootContext(ReviewStep)
